/** VERSION: 0.0.3 Please do not delete this line. Thank you! **/
if(typeof lazySizes !== 'function' && typeof lazySizes !== 'object'){
	/*! lazysizes - v4.1.8 */
	!function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
	/*! ls.rias.min.ks - v4.1.8 */
	!function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
general: {
	limit: boostPFSThemeConfig.custom.products_per_page,
	/* Optional */
	loadProductFirst: false,
	// Placeholder  
	showPlaceholderProductList: true,
	placeholderProductPerRow: 3,
	placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
	enableOTP: true,
	filterTreeMobileStyle: 'style1', // 'style2', 'style3',
	equal_height: boostPFSThemeConfig.custom.equal_height,
	cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.equal_height_crop_image_position,
	defaultDisplay: boostPFSThemeConfig.custom.product_item_type,
			enableAjaxCart: true,
	ajaxCartStyle: 'slide', // 'slide' or 'popup'
	showAjaxCartOnAdd: true, // Opens the ajax cart after add to cart
	autoCloseMiniCart: false, // Auto close the cart after add to cart > open cart > close cart
	autoCloseMiniCartDuration: 2000,
	selectOptionInProductItem: true, // Append the product's option inside the product item when clicking "select option"
	selectOptionContainer: '.boost-pfs-filter-product-item-image',  // CSS selector to append the product option, if left empty it will append to the product item
	},
selector: {
// 		otpButtons: '.boost-pfs-filter-product-item-image'
},
	boostProductOptionSwatch: {
			color: {
					swatchName: 'Color',
					optionName: 'color',
					swatchDisplay: boostPFSThemeConfig.custom.display_item_swatch,
					swatchType: boostPFSThemeConfig.custom.swatch_color_display_type
			},
			size: {
					swatchName: 'Size',
					optionName: 'size',
					swatchDisplay: boostPFSThemeConfig.custom.display_item_swatch_size,
					swatchType: ''
			}
	}
};

(function() {
var onSale = false,
	soldOut = false,
	priceVaries = false,
	images = [],
	firstVariant = {},
	boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
	boostPFSRangeWidths = [180, 360, 540, 720];


BoostPFS.inject(this);
boostPFSFilterConfig.general.separateRefineByFromFilter = jQ('.boost-pfs-filter-tree-h').length > 0 ? true : false;

/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
	// Displaying price base on the policy of Shopify, have to multiple by 100
	soldOut = !data.available; // Check a product is out of stock
	onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Convert images to array and filter out pdp only images
	images = data.images_info.filter((image) => {
		if (!image.src.includes('pdp-only')) return image;
		return false;
	});
	// Get First Variant (selected_or_first_available_variant)
	firstVariant = data['variants'][0];
	if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
		var paramVariant = data.variants.filter(function(e) {
			return e.id == Utils.getParam('variant');
		});
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	}
	data.selected_or_first_available_variant = firstVariant;
	return data;
}

/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
ProductGridItem.prototype.compileTemplate = function(data) {
	if (!data) data = this.data;
	// Customize API data to get the Shopify data
	data = prepareShopifyData(data);
	//Metafields
	var metafields = {};
	data.metafields.map(function(field){
		metafields[field.key] = field.value;
		return null;
	})
	// Get Template
	var itemHtml = boostPFSTemplate.productGridItemHtml;
	// Add Custom class
	var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
	var saleClass = onSale ? boostPFSTemplate.saleClass : '';

	itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
	itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
	// Add Grid Width class
	itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
	// Add Label
	itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
	// Add TAG Label
	itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
	// Add Images
	itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
	// Add Price
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

	// Add Review
	if (typeof Integration === 'undefined' ||
		(typeof Integration != 'undefined' &&
			typeof Integration.hascompileTemplate == 'function' &&
			!Integration.hascompileTemplate('reviews'))) {
		itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
	}

	// Add Vendor
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

	// itemActiveSwapClass
	itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));

	// Add Color Swatches
	itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildProductOptionSwatches(data, boostPFSFilterConfig.boostProductOptionSwatch.color.swatchName, boostPFSFilterConfig.boostProductOptionSwatch.color.optionName, boostPFSFilterConfig.boostProductOptionSwatch.color.swatchDisplay, boostPFSFilterConfig.boostProductOptionSwatch.color.swatchType ));

			// Add Size Swatch
			itemHtml = itemHtml.replace(/{{itemSizeSwatches}}/g, buildProductOptionSwatches(data, boostPFSFilterConfig.boostProductOptionSwatch.size.swatchName, boostPFSFilterConfig.boostProductOptionSwatch.size.optionName, boostPFSFilterConfig.boostProductOptionSwatch.size.swatchDisplay, boostPFSFilterConfig.boostProductOptionSwatch.size.swatchType ));

			// Add data json
			itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data));


	var itemWishlistHtml = '<p data-product-id="' + data.id + '" class="clp-fav-btn show-blank"><span class="blank-fav-icon open-modal" data-modal-type="show-list-selection" data-variant-id="' + data.selected_or_first_available_variant.id + '" data-product-id="' + data.id + '" data-product-url="' + theme.shop_url + '/products/' + data.handle + '" data-product-has-size-variant="'+checkVariant(data, 'size')+'" data-product-has-color-variant="'+checkVariant(data, 'colour')+'" data-save-size-variant="false"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-heart icon--stroke-based"  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.0057 19.5216L4.36699 12.6025C0.21554 8.45103 6.31817 0.48025 12.0057 6.92884C17.6931 0.48025 23.7681 8.47871 19.6443 12.6025L12.0057 19.5216Z" stroke="black" stroke-width="1.71429" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span class="filled-fav-icon hidden remove-product-from-wishlist" data-variant-id="' + data.selected_or_first_available_variant.id + '" data-product-id="' + data.id + '" data-product-url="' + theme.shop_url + '/products/' + data.handle + '" data-product-has-size-variant="'+checkVariant(data, 'size')+'" data-product-has-color-variant="'+checkVariant(data, 'colour')+'" data-save-size-variant="false"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-heart"  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.0057 19.5216L4.36699 12.6025C0.21554 8.45103 6.31817 0.48025 12.0057 6.92884C17.6931 0.48025 23.7681 8.47871 19.6443 12.6025L12.0057 19.5216Z" stroke="black" stroke-width="1.71429" stroke-linecap="round" stroke-linejoin="round"/></svg></span></p>';

	itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

	// Add main attribute (Always put at the end of this function)
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
	itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
	itemHtml = itemHtml.replace(/{{itemPromotionalLabelElement}}/g, buildPromotionalLabel(metafields));
	itemHtml = itemHtml.replace(/{{siblingID}}/g, data.id);
	
	async function hasMetaSwatches(jitterbitField) {
		let graphQuery = ""

		JSON.parse(jitterbitField[0].value).forEach((item, index) => {
			graphQuery+= `product${index}: product(id: "${item}") {
				availableForSale
			}`
		})

		const options = {
			method: 'POST',
			headers: new Headers({
				'content-type': 'application/json', 
				'X-Shopify-Storefront-Access-Token': window.gqlProductInfoStorefrontAccessToken,
			}),
			body: JSON.stringify({
        query: `
					query products {
						${graphQuery}
					}
				`
      }),
		};

		const request = fetch('/api/2023-04/graphql.json', options)
		const response = (await request).json();
		const siblings = await response;

		let count = 0;

		Object.values(siblings.data).forEach(item => {
			if (item.availableForSale) count ++
		})

		let selector = `[sibling-id="${data.id}"]`

		if (count > 1) {
			document.querySelector(selector).innerText = `${count} Colours`;
			document.querySelector(selector).style.display = 'block';
		}
	}

	let jitterbitField = data.metafields.filter(item => item.namespace == "jitterbit" && item.key == "related_products");
	if (jitterbitField)
		hasMetaSwatches(jitterbitField)

	return itemHtml;
};
// Build Product List Item
ProductListItem.prototype.compileTemplate = function(data) {
	if (!data) data = this.data;
	// Customize API data to get the Shopify data
	data = prepareShopifyData(data);

	// For List View
	// Get Template
	var itemHtml = boostPFSTemplate.productListItemHtml;

	// Add Custom class
	var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
	var saleClass = onSale ? boostPFSTemplate.saleClass : '';

	itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
	itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
	// Add Label
	itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
	// Add TAG Label
	itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
	// Add Images
	itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

	// Add Review
	if (typeof Integration === 'undefined' ||
		(typeof Integration != 'undefined' &&
			typeof Integration.hascompileTemplate == 'function' &&
			!Integration.hascompileTemplate('reviews'))) {
		itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
	}

	// Add Vendor
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

	// Add Price
	var itemPriceHtml = buildPrice(data, onSale, priceVaries);
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	// Description
	var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
	itemDescription = (itemDescription.split(" ")).length > 35 ? itemDescription.split(" ").splice(0, 35).join(" ") + '...' : itemDescription.split(" ").splice(0, 35).join(" ");
	itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

	// itemActiveSwapClass
	itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));

	// Add Color Swatches
	itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildProductOptionSwatches(data, boostPFSFilterConfig.boostProductOptionSwatch.color.swatchName, boostPFSFilterConfig.boostProductOptionSwatch.color.optionName, boostPFSFilterConfig.boostProductOptionSwatch.color.swatchDisplay, boostPFSFilterConfig.boostProductOptionSwatch.color.swatchType ));

			// Add Size Swatch
			itemHtml = itemHtml.replace(/{{itemSizeSwatches}}/g, buildProductOptionSwatches(data, boostPFSFilterConfig.boostProductOptionSwatch.size.swatchName, boostPFSFilterConfig.boostProductOptionSwatch.size.optionName, boostPFSFilterConfig.boostProductOptionSwatch.size.swatchDisplay, boostPFSFilterConfig.boostProductOptionSwatch.size.swatchType ));

	// Add main attribute
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);

	return itemHtml;
	// End For List View
};

/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
function checkVariant(data, option){
	if (typeof data.options != 'undefined' && data.options.length > 0) {
		data_options = data.options;
		return data_options.includes(option);
	}
	return false;
}
function buildGridWidthClass() {
	var gridWidthClass = '';
	// On PC
			if (!Cookies.get("gridDisplayType") || Cookies.get("gridDisplayType") == 4) {
					// collectionDisplayType.find('.four-column-display').addClass('active');
					gridWidthClass = 'one-quarter';
			} else if (Cookies.get("gridDisplayType") == 2) {
					// collectionDisplayType.find('.two-column-display').addClass('active');
					gridWidthClass = 'one-half';
			} else if (Cookies.get("gridDisplayType") == 6) {
					// collectionDisplayType.find('.six-column-display').addClass('active');
					gridWidthClass = 'one-sixth';
			}
	// On Mobile
	switch (boostPFSThemeConfig.custom.products_per_row_mobile) {
		case 1:
			gridWidthClass += ' boost-pfs-filter-grid-width-mb-1';
			break;
		case 3:
			gridWidthClass += ' boost-pfs-filter-grid-width-mb-3';
			break;
		default:
			gridWidthClass += ' boost-pfs-filter-grid-width-mb-2';
			break;
	}
	return gridWidthClass;
}

function buildImages(data) {
	var html = '',
		aspectRatio = '',
		rangeWidths = boostPFSRangeWidths,
		paddingTop = 100;

	var dataSrcSet = '',
		dataWidths = '',
		dataSizes = 'auto',
		imgAlt = data.title,
		flipImageSrcSet = '';

	var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
		boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
		boostPFSThemeConfig.custom.active_image_swap == true;

	for (var i = 0; i < rangeWidths.length; i++) {
		dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
		dataWidths += rangeWidths[i];

		if (activeSwapImage) {
			flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
		}

		if (i < rangeWidths.length - 1) {
			dataSrcSet += ', ';
			dataWidths += ', ';

			if (activeSwapImage) {
				flipImageSrcSet += ', ';
			}
		}
	}

	if (images.length > 0) {
		aspectRatio = images[0]['width'] / images[0]['height'];
		paddingTop = 1 / aspectRatio * 100;

		html += '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link" ';
		html += 'style="padding-top:' + paddingTop + '%;">';
		html += '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad ariz"' +
			'data-srcset="' + dataSrcSet + '" ' +
			'data-src="' + Utils.getFeaturedImage(images, rangeWidths[2] + 'x') + '" ' +
			'data-widths="[' + dataWidths + ']" ' +
			'data-sizes="' + dataSizes + '" ' +
			'src="' + boostPFSImgDefaultSrc + '" ' +
			'alt="' + imgAlt + '" ' +
			'loading="lazy" ' +
			'width="' + images[0]['width'] + '" ' +
			'height="' + images[0]['height'] + '" ';

		if (activeSwapImage) {
			html += 'data-img-flip-src="' + Utils.optimizeImage(images[1]['src'], rangeWidths[2] + 'x') + '" ' +
				'data-img-flip-srcset="' + flipImageSrcSet + '" ';
		}
		html += '/></a>';
	}

	return html;
}

function buildPromotionalLabel(metafields){
	var html = '';
	if (typeof metafields.promotional_label !== 'undefined'){
		var promotional_label = metafields.promotional_label;
    const icon_eco_collection = `
    <svg width="90" height="22" viewBox="0 0 90 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="89.2076" height="22" rx="11" fill="#F2F2F2"/>
      <path d="M13.4 8.196L12.416 8.772C12.344 8.592 12.236 8.424 12.056 8.268C11.804 8.064 11.54 7.98 11.192 7.98C10.448 7.98 10.064 8.424 10.064 8.94C10.064 9.18 10.148 9.6 10.928 9.912L11.732 10.236C13.208 10.836 13.616 11.676 13.616 12.588C13.616 14.112 12.536 15.156 11.036 15.156C10.112 15.156 9.56 14.808 9.152 14.352C8.72 13.872 8.528 13.344 8.48 12.792L9.692 12.528C9.692 12.924 9.836 13.296 10.028 13.548C10.256 13.836 10.592 14.028 11.072 14.028C11.816 14.028 12.392 13.488 12.392 12.684C12.392 11.868 11.768 11.532 11.24 11.316L10.472 10.992C9.812 10.716 8.84 10.164 8.84 8.964C8.84 7.884 9.68 6.852 11.18 6.852C12.044 6.852 12.536 7.176 12.788 7.392C13.004 7.584 13.232 7.86 13.4 8.196ZM14.9315 9.948H16.1075V12.84C16.1075 13.14 16.1195 13.488 16.3235 13.752C16.4795 13.956 16.7555 14.1 17.0915 14.1C17.4275 14.1 17.7035 13.956 17.8595 13.752C18.0635 13.488 18.0755 13.14 18.0755 12.84V9.948H19.2515V12.876C19.2515 13.524 19.1795 14.064 18.7115 14.532C18.2555 14.988 17.6315 15.156 17.0675 15.156C16.5515 15.156 15.9275 15 15.4715 14.532C15.0035 14.064 14.9315 13.524 14.9315 12.876V9.948ZM23.828 10.704L22.952 11.28C22.832 11.088 22.604 10.848 22.232 10.848C22.064 10.848 21.944 10.908 21.872 10.98C21.812 11.04 21.764 11.136 21.764 11.244C21.764 11.376 21.824 11.46 21.932 11.532C22.004 11.58 22.076 11.604 22.328 11.736L22.928 12.036C23.192 12.168 23.444 12.3 23.636 12.504C23.912 12.78 24.008 13.092 24.008 13.44C24.008 13.896 23.84 14.292 23.564 14.592C23.168 15.024 22.676 15.156 22.148 15.156C21.824 15.156 21.416 15.108 21.056 14.832C20.768 14.616 20.528 14.268 20.408 13.908L21.368 13.452C21.428 13.62 21.536 13.836 21.644 13.932C21.716 14.004 21.884 14.124 22.16 14.124C22.34 14.124 22.532 14.064 22.64 13.956C22.736 13.86 22.808 13.704 22.808 13.56C22.808 13.416 22.76 13.296 22.652 13.176C22.508 13.032 22.34 12.948 22.148 12.864L21.716 12.66C21.488 12.552 21.212 12.42 21.02 12.228C20.756 11.976 20.66 11.7 20.66 11.376C20.66 10.968 20.816 10.572 21.08 10.296C21.308 10.056 21.692 9.816 22.316 9.816C22.676 9.816 22.964 9.888 23.252 10.08C23.42 10.188 23.648 10.38 23.828 10.704ZM27.1802 11.028H26.2802V15H25.1042V11.028H24.6122V9.948H25.1042V8.1H26.2802V9.948H27.1802V11.028ZM31.6705 10.536V9.948H32.8465V15H31.6705V14.472C31.1545 15.072 30.5185 15.156 30.1585 15.156C28.5985 15.156 27.7105 13.86 27.7105 12.468C27.7105 10.824 28.8385 9.816 30.1705 9.816C30.5425 9.816 31.1905 9.912 31.6705 10.536ZM30.3145 10.872C29.4625 10.872 28.9105 11.592 28.9105 12.492C28.9105 13.368 29.4625 14.1 30.3145 14.1C31.0585 14.1 31.7425 13.56 31.7425 12.504C31.7425 11.4 31.0585 10.872 30.3145 10.872ZM34.3378 9.948H35.5138V15H34.3378V9.948ZM34.1698 7.86C34.1698 7.428 34.4938 7.104 34.9258 7.104C35.3577 7.104 35.6818 7.428 35.6818 7.86C35.6818 8.292 35.3577 8.616 34.9258 8.616C34.4938 8.616 34.1698 8.292 34.1698 7.86ZM36.9859 15V9.948H38.1619V10.416C38.6659 9.852 39.2419 9.816 39.5299 9.816C40.4659 9.816 40.8619 10.284 41.0179 10.5C41.2099 10.776 41.3299 11.124 41.3299 11.904V15H40.1539V12.192C40.1539 10.908 39.6739 10.872 39.2299 10.872C38.7019 10.872 38.1619 10.944 38.1619 12.576V15H36.9859ZM46.5181 10.536V9.948H47.6941V15H46.5181V14.472C46.0021 15.072 45.3661 15.156 45.0061 15.156C43.4461 15.156 42.5581 13.86 42.5581 12.468C42.5581 10.824 43.6861 9.816 45.0181 9.816C45.3901 9.816 46.0381 9.912 46.5181 10.536ZM45.1621 10.872C44.3101 10.872 43.7581 11.592 43.7581 12.492C43.7581 13.368 44.3101 14.1 45.1621 14.1C45.9061 14.1 46.5901 13.56 46.5901 12.504C46.5901 11.4 45.9061 10.872 45.1621 10.872ZM50.3614 6.252V10.536C50.8414 9.912 51.4894 9.816 51.8614 9.816C53.1934 9.816 54.3214 10.824 54.3214 12.468C54.3214 13.86 53.4334 15.156 51.8734 15.156C51.5134 15.156 50.8774 15.072 50.3614 14.472V15H49.1854V6.252H50.3614ZM51.7174 10.872C50.9734 10.872 50.2894 11.4 50.2894 12.504C50.2894 13.56 50.9734 14.1 51.7174 14.1C52.5694 14.1 53.1214 13.368 53.1214 12.492C53.1214 11.592 52.5694 10.872 51.7174 10.872ZM55.5487 6.252H56.7247V15H55.5487V6.252ZM61.7488 13.296L62.7328 13.848C62.5168 14.232 62.2048 14.568 61.8808 14.772C61.4728 15.036 60.9328 15.156 60.3928 15.156C59.7208 15.156 59.1688 14.988 58.6888 14.508C58.2088 14.028 57.9448 13.332 57.9448 12.576C57.9448 11.796 58.2208 11.04 58.7488 10.5C59.1688 10.08 59.7208 9.816 60.4408 9.816C61.2448 9.816 61.7608 10.164 62.0608 10.476C62.7088 11.148 62.7688 12.084 62.7688 12.612V12.756H59.1448C59.1688 13.116 59.3248 13.524 59.5768 13.776C59.8528 14.052 60.1888 14.1 60.4768 14.1C60.8008 14.1 61.0408 14.028 61.2808 13.848C61.4848 13.692 61.6408 13.488 61.7488 13.296ZM59.2288 11.796H61.5688C61.5208 11.52 61.3888 11.28 61.2088 11.112C61.0528 10.968 60.8008 10.824 60.4168 10.824C60.0088 10.824 59.7448 10.992 59.5888 11.148C59.4208 11.304 59.2888 11.544 59.2288 11.796Z" fill="#27AE60"/>
      <g clip-path="url(#clip0_1305_3733)">
      <path d="M75.1585 14.2755C76.6377 14.2755 78.0906 13.7208 79.1736 12.717C81.1283 10.8679 81.1811 8.06794 81.1811 7.96228C81.1811 7.69813 81.0226 7.48681 80.7585 7.40756C78.4604 6.80001 76.3208 8.1736 75.1321 9.17737C75.1321 7.80379 74.5774 6.45662 73.6 5.42643C72.4377 4.29058 70.7208 3.81511 68.5019 4.05284C68.2113 4.07926 68 4.317 68 4.60756C68 4.66039 68.0792 10.7094 74.0491 11.0528V18H75.1585V14.2755ZM74.0491 9.89058V9.96983C70.0604 9.67926 69.2943 6.40379 69.1358 5.10945C70.7472 5.0302 71.9887 5.40001 72.8075 6.21888C74.234 7.59247 74.0491 9.81134 74.0491 9.89058ZM75.1585 10.7359C75.6868 10.1811 77.8 8.12077 80.0453 8.41134C79.9132 9.73209 79.3321 10.9736 78.4075 11.951C77.5094 12.7434 76.3472 13.1925 75.1585 13.1925V10.7359Z" fill="#27AE60"/>
      </g>
      <defs>
      <clipPath id="clip0_1305_3733">
      <rect width="13.2075" height="14" fill="white" transform="translate(68 4)"/>
      </clipPath>
      </defs>
    </svg>`; 
		html = '<label class="promotional-label promotional-label-'+promotional_label.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "")+'">'+icon_eco_collection+'</label>';
	}
	return html;
}

function buildVendor(data) {
	var html = '';
	if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
		boostPFSThemeConfig.custom.show_vendor == true) {
		html = boostPFSTemplate.vendorHtml;
	}
	return html;
}

function buildPrice(data) {
	var html = '';
	if (boostPFSThemeConfig.custom.hasOwnProperty('show_price') &&
		boostPFSThemeConfig.custom.show_price) {
		html = '<p class="boost-pfs-filter-product-item-price">';
		if (onSale) {
							html += '<s>' + Utils.formatMoney(data.compare_at_price_min) + '</s> ';
							html += '<span class="boost-pfs-filter-product-item-sale-price">' + boostPFSThemeConfig.label.sale_price_label + " " + Utils.formatMoney(data.price_min) + ' (' + data.percent_sale_min + '% Off)</span>';
			
		} else {
			if (priceVaries) {
				html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label_basic.from) + ' ' + '</span>';
			}
			html += '<span class="boost-pfs-filter-product-item-regular-price">' + Utils.formatMoney(data.price_min);
			if (data.template_suffix == 'gift-card' && data.price_max) html += ' - ' + Utils.formatMoney(data.price_max);
			html += '</span>';
		}
		html += '</p>';
	}
	return html;
}

function buildLabels(data) {
	// Build Sold out label
	var soldOutLabel = '';
	if (boostPFSThemeConfig.custom.hasOwnProperty('show_sold_out_label') &&
		boostPFSThemeConfig.custom.show_sold_out_label && soldOut) {
		soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
	}
	// Build Sale label
	var saleLabel = '';
			var salePercent = '';
	if (boostPFSThemeConfig.custom.show_sale_label && onSale && !soldOut) {
					if (boostPFSThemeConfig.custom.show_sale_percent){
							salePercent = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_max);
					}
		saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
					saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{salePercent}}/g, salePercent + '%');
	}
	// Build Labels
	return soldOutLabel + saleLabel;
}

// BUILD LABEL PRODUCT WITH TAGS
function buildTagLabels(data, showall) {
	if (boostPFSThemeConfig.custom.show_label_by_tag) {
		if (showall) {
			var tagLabel = '';
			if (data.tags) {
				for (var i = 0; i < data.tags.length; i++) {
					var tag = data.tags[i];
					if (tag.indexOf("pfs:label") !== -1) {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
						tagLabel += preTagLabel;
					}
				}
			}
		} else {
			var tagLabel = '';
			if (data.tags) {
				for (var i = data.tags.length - 1; i >= 0; i--) {
					tag = data.tags[i];
					if (tag.indexOf("pfs:label") !== -1) {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
						tagLabel += preTagLabel;
						break;
					}
				}
			}
		}
		return tagLabel;
	} else {
		return "";
	}
}

// Build Color Swatches
function buildProductOptionSwatches(data, swatchName, optionName, swatchDisplay, swatchType) {
	var swatchesProductOptionHtml = '',
		filterSwatchTitle = swatchName,
		optionName = optionName,
		swatchArr = [],
		countSwatch = 0,
		swatchValues = [],
		swatchLimit = 4;

	var dataImgSize = '360',
		bgSize = '50x',
		dataImgSrc = Utils.getFeaturedImage(data.images_info, dataImgSize + 'x'),
		swatchName = '#ffffff',
		bgImageSrc = '',
		viewMoreLabel = 'More ' + filterSwatchTitle;

	if (swatchDisplay) {
		if (typeof data.options_with_values != 'undefined' && data.options_with_values.length > 0) {
			swatchArr = data.options_with_values.filter(function(option) {
				return option.name == optionName;
			});
			if (swatchArr.length > 0) {
				countSwatch = swatchArr[0].values.length;

				if (swatchLimit > countSwatch) {
					swatchLimit = countSwatch;
				}
				swatchValues = swatchArr[0].values;

				swatchesProductOptionHtml += '<ul class="boost-pfs-filter-item-swatch boost-pfs-filter-item-swatch-' + optionName + ' ">';

				for (var sIndex = 0; sIndex < swatchLimit; sIndex++) {
					swatchName = swatchValues[sIndex].title;
											swatchVariant = data['variants'][sIndex];
					sImageIndex = swatchValues[sIndex].image || '';
					if (sImageIndex != '') {
						dataImgSrc = Utils.optimizeImage(data.images[sImageIndex], dataImgSize + 'x') + ' ' + dataImgSize + 'w';
					}


					if (swatchType) {
						switch (swatchType) {
							case 'swatch_color_display_type_image_color':
								bgImageSrc = boostPFSAppConfig.general.file_url.replace(/\?/, Utils.slugify(filterSwatchTitle).replace(/\-/g, '_') + '-' + Utils.slugify(swatchName) + '.png?v=');
								break;
							case 'swatch_color_display_type_image_product':
								bgImageSrc = Utils.getFeaturedImage(data.images_info, bgSize);
								if (sImageIndex != '') {
									bgImageSrc = Utils.optimizeImage(data.images[sImageIndex], bgSize);
								}
								break;
							default:
								bgImageSrc = '';
						}
					}

					swatchesProductOptionHtml += '<li>';
											if(optionName == 'color' || optionName == 'colour'){
													swatchesProductOptionHtml += '<div class="boost-pfs-product-item-tooltip">' + swatchName + '</div>';
													swatchesProductOptionHtml += '<span tabindex="0" aria-label="' + swatchName + '" ' +
															'style="background-color: ' + swatchName + '; ';
													if (bgImageSrc != '') {
															swatchesProductOptionHtml += 'background-image: url(' + bgImageSrc + ');" ';
													} else {
															swatchesProductOptionHtml += '" ';
													}
													if (dataImgSrc != '') {
															swatchesProductOptionHtml += 'data-img="' + dataImgSrc + '" ';
													}

													swatchesProductOptionHtml += '></span>';
											} else {
													swatchesProductOptionHtml += '<a title="' + swatchName + '" href="' + Utils.buildProductItemUrl(data) + '?variant=' + swatchVariant.id + '">' + swatchName + '</a>';
											}
					swatchesProductOptionHtml += '</li>';
				}

				if (countSwatch > swatchLimit) {
					swatchesProductOptionHtml += '<li class="boost-pfs-filter-item-swatch-more">';
					swatchesProductOptionHtml += '<a href="{{itemUrl}}" title="' + viewMoreLabel + '">+' + (countSwatch - swatchLimit) + '</a>';
					swatchesProductOptionHtml += '</li>';
				}

				swatchesProductOptionHtml += '</ul>';
			}
		}
	}
	return swatchesProductOptionHtml;
}

// Build Color Swatches
function eventColorSwatches(event) {
	jQ('.boost-pfs-filter-item-swatch li span').each(function() {
		var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
		if (event == 'hover') {
			jQ(this).hover(function() {
				var newImage = jQ(this).data('img');
				img.attr('srcset', newImage);
			});
		}
		if (event == 'click') {
			jQ(this).click(function() {
				var newImage = jQ(this).data('img');
				img.attr('srcset', newImage);
			});
		}
		jQ(this).focus(function() {
			if (jQ('body').hasClass('boost-pfs-ada')) {
				var newImage = jQ(this).data('img');
				img.attr('srcset', newImage);
			}
		});
	});
}

function buildReview(data) {
	var html = '';
	if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
		boostPFSThemeConfig.custom.show_product_review == true) {
		html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
	}
	return html;
}

function buildActiveSwapClass(data) {
	if (!Utils.isMobile() && images.length > 1 &&
		boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
		boostPFSThemeConfig.custom.active_image_swap == true) {
		return 'has-bc-swap-image';
	}
	return '';
}



/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
	if (!totalProduct) totalProduct = this.totalProduct;
	// Get page info
	var currentPage = parseInt(Globals.queryParams.page);
	var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
	// If it has only one page, clear Pagination
	if (totalPage <= 1) {
		return '';
	}

	var paginationHtml = boostPFSTemplate.paginateHtml;

			paginationHtml = paginationHtml.replace(/{{selectBox}}/g, boostPFSTemplate.paginationSelecBox);

			// Add total page
			paginationHtml = paginationHtml.replace(/{{totalPage}}/g, totalPage);

	// Build Previous
	var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
	//previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
	previousHtml = previousHtml.replace(/{{itemPage}}/g,  currentPage - 1);
	paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
	// Build Next
	var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
	//nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
	nextHtml = nextHtml.replace(/{{itemPage}}/g,  currentPage + 1);
	paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
	// Create page items array
	var beforeCurrentPageArr = [];
	for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
		beforeCurrentPageArr.unshift(iBefore);
	}
	if (currentPage - 4 > 0) {
		beforeCurrentPageArr.unshift('...');
	}
	if (currentPage - 4 >= 0) {
		beforeCurrentPageArr.unshift(1);
	}
	beforeCurrentPageArr.push(currentPage);
	var afterCurrentPageArr = [];
	for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
		afterCurrentPageArr.push(iAfter);
	}
	if (currentPage + 3 < totalPage) {
		afterCurrentPageArr.push('...');
	}
	if (currentPage + 3 <= totalPage) {
		afterCurrentPageArr.push(totalPage);
	}
	// Build page items
	var pageItemsHtml = '';
			var selectBoxItemsHtml = '';
	var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
	for (var iPage = 1; iPage <= totalPage; iPage++) {          
					selectBoxItemsHtml += (iPage == currentPage) ? boostPFSTemplate.paginationSelecBoxItemSelected : boostPFSTemplate.paginationSelecBoxItem;
					selectBoxItemsHtml = selectBoxItemsHtml.replace(/{{numberValue}}/g, iPage);
					selectBoxItemsHtml = selectBoxItemsHtml.replace(/{{numberItem}}/g, iPage);
	}
	paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			paginationHtml = paginationHtml.replace(/{{pageNumbers}}/g, selectBoxItemsHtml);
			
			var numberList = '24,36,48';
			if (numberList != '') {
				// Build content
				var showLimitItemsHtml = '';
				var showLimitOptions = '';
				var arr = numberList.split(',');
				for (var k = 0; k < arr.length; k++) {
					var label = arr[k];
					showLimitOptions += boostPFSTemplate.showLimitOption.replace(/{{viewText}}/g, boostPFSThemeConfig.label.view + ' ' + label).replace(/{{limitValue}}/g, label);
				}
				var showItemTotal = boostPFSTemplate.showLimitTotal.replace(/{{viewTotal}}/g, boostPFSThemeConfig.label.view + ' ' + Globals.queryParams.limit);

				paginationHtml = paginationHtml.replace(/{{showViewTotal}}/g, showItemTotal);
				paginationHtml = paginationHtml.replace(/{{showItemValues}}/g, showLimitOptions);

			}

	return paginationHtml;
};


ProductPaginationDefault.prototype.bindEvents = function () {
			var _this = this;
	// Display the pagination block
	_this.$element.show();
	// Unbind default event on pagination

	_this.$element.find('select').change(function(event) {
		// Append "sort" param to url
		// Used to Scroll to the previous position after returning from Product page
		FilterApi.setParam('page', jQ(this).val());
		FilterApi.applyFilter('page');

		// Scroll to top of product list
		jQ('body,html').animate({
			//scrollTop: _this.$productList.offset().top - 50
			scrollTop: 0
		}, 600);
	});

	_this.$element.find('.show-limit-option').unbind('click');
	_this.$element.find('.show-limit-option').on('click', function(event) {
		event.preventDefault();
		Globals.internalClick = true;

		FilterApi.setParam('limit', jQ(this).data('limit-value'));
		FilterApi.setParam('page', 1);
		FilterApi.applyFilter();
	});

	_this.$element.find('.turn-page').unbind('click');
	_this.$element.find('.turn-page').on('click', function(event) {
		event.preventDefault();
		var page = event.target.getAttribute('data-page');
		FilterApi.setParam('page', page);
		FilterApi.applyFilter('page');
		// Scroll to top of product list
		jQ('body,html').animate({
			scrollTop: 0
	}, 600);
	});
}

// Build Sorting
ProductSorting.prototype.compileTemplate = function() {
	var html = '';
	if (boostPFSThemeConfig.custom.show_toolbar_sort_by && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
		var sortingArr = Utils.getSortingList();
		if (sortingArr) {
			var paramSort = Globals.queryParams.sort || '';
			// Build content
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				activeClass = '';
				if (paramSort == k) {
					activeClass = 'boost-pfs-filter-sort-item-active';
				}
				sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
			}
			html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
		}
	}
	return html;
};

ProductSorting.prototype.render = function() {
	jQ(Selector.topSorting).html(this.compileTemplate());

	if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
		jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
	}

	var labelSort = '';
	var paramSort = Globals.queryParams.sort || '';
	var sortingList = Utils.getSortingList();
	if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
		labelSort = sortingList[paramSort];
	} else {
		labelSort = Labels.sorting_heading;
	}

	jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
}

// Build Sorting event
ProductSorting.prototype.bindEvents = function() {
	var _this = this;
	jQ('.boost-pfs-filter-filter-dropdown a').click(function(e) {
		e.preventDefault();
		FilterApi.setParam('sort', jQ(this).data('sort'));
		FilterApi.setParam('page', 1);
		FilterApi.applyFilter('sort');
	});

	jQ(".boost-pfs-filter-custom-sorting > button").click(function() {
		if (!jQ('.boost-pfs-filter-filter-dropdown').is(':animated')) {
			jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
		}
	});

	jQ(Selector.filterTreeMobileButton).click(function() {
		jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
	});

			jQ(document).on('click', function (e) {
					if (jQ(e.target).parents('.boost-pfs-filter-top-sorting').find(".boost-pfs-filter-filter-dropdown").length === 0) {
							jQ('.boost-pfs-filter-filter-dropdown').hide().parent().removeClass('boost-pfs-filter-sort-active');
					}
			});
};

// For Toolbar - Build Display type
ProductDisplayType.prototype.compileTemplate = function() {
	var itemHtml = '';

	itemHtml = boostPFSTemplate.newDisplayTypeOption;
		
			

	return itemHtml;
};

	var originalRenderProductDisplayType = ProductDisplayType.prototype.render;
	ProductDisplayType.prototype.render = function() {
			// Call the original function in our app lib.
			// We don't have to copy a very big function out here to modify.
			// function.call(this, param1, param2) binds the "this" pointer and params to the original function.
			originalRenderProductDisplayType.call(this);
		
			var setGridNumber = function(gridNumber) {
				$('.single-product-block').each(function() {
					var singleProduct = $(this);
					if (singleProduct.hasClass('one-half') && !singleProduct.hasClass('grid-ads')) {
						singleProduct.removeClass('one-half');
					} else if (singleProduct.hasClass('one-quarter')) {
						singleProduct.removeClass('one-quarter');
					} else if (singleProduct.hasClass('one-sixth')) {
						singleProduct.removeClass('one-sixth');
					}

					if (!singleProduct.hasClass('one-whole') && (!singleProduct.hasClass('one-half') && !singleProduct.hasClass('grid-ads'))) {
						if (gridNumber == 2) {
							singleProduct.addClass(	'one-half');
						}  else if (gridNumber == 6) {
							singleProduct.addClass('one-sixth');
						} else if (gridNumber == 4 || gridNumber == 0 || gridNumber == undefined) {
							singleProduct.addClass('one-quarter');
						}
					}
				});
			};

			// Do your custom code after the original function has run
			// Active current display type
			if (this.$element.length) {
					if (!Cookies.get("gridDisplayType") || Cookies.get("gridDisplayType") == 4) {
						this.$element.find('.four-column-display').addClass('active');
					} else if (Cookies.get("gridDisplayType") == 2) {
						this.$element.find('.two-column-display').addClass('active');
					} else if (Cookies.get("gridDisplayType") == 6) {
						this.$element.find('.six-column-display').addClass('active');
					}
				
					this.$element.find('a.grid-display-option').off('click').on('click', function(e) {
							var gridNumberValue = jQ(this).attr('rel');
							var gridNumberInt = parseInt(gridNumberValue);
							Cookies.set("gridDisplayType", gridNumberValue);
							jQ('.grid-display-option.active').removeClass('active');
							jQ(this).addClass('active');
							setGridNumber(gridNumberInt);

							e.preventDefault();
					});
			}
	}

// Build Show Limit
ProductLimit.prototype.compileTemplate = function() {
	var html = '';
	if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {

		var numberList = Settings.getSettingValue('general.showLimitList');
		if (numberList != '') {
			// Build content
			var showLimitItemsHtml = '';
			var arr = numberList.split(',');
			for (var k in sortingArr) {
				showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
			}
			html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
		}
	}
	return html;
};
// Build Breadcrumb
Breadcrumb.prototype.compileTemplate = function(colData) {
	if (!colData) colData = this.collectionData;
	var breadcrumbItemsHtml = '';
	if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
		if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
			var colInfo = colData.collection;
			if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
				breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
				breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
				breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
			} else {
				breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
			}
		} else {
			breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
		}
	}
	return breadcrumbItemsHtml
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
ProductList.prototype.afterRender = function(data) {
	if (!data) data = this.data;

	// Intergrate Review Shopify
	if (window.SPR &&
		typeof window.SPR.initDomEls == 'function' &&
		typeof window.SPR.loadBadges == 'function' &&
		boostPFSThemeConfig.custom.show_product_review) {
		window.SPR.initDomEls();
		window.SPR.loadBadges();
	}

	for (var i = 0; i < data.length; i++) {
		var selectedData = data[i];
		var prodId = selectedData.id;
		var singleGridBlock = $('.single-product-block[data-product-id="product-id-' + prodId + '"]');
		var grid_ads_element = document.getElementById('collection-grid-ads');

		if (typeof(grid_ads_element) != 'undefined' && grid_ads_element != null) {
			var ads_data = JSON.parse(document.getElementById('collection-grid-ads').textContent);
			for (var x = 0; x < ads_data.grid_ads.length; x++) {
				var gridAdsHtml = '';
				render_location_index = ads_data.grid_ads[x].render_location - 1;
					switch(ads_data.grid_ads[x].type) {
						case 'full-width-ads':
							gridAdsHtml = boostPFSTemplate.fullWidthAdsHtml;
							break;
						case 'one-half-width-ads':
							gridAdsHtml = boostPFSTemplate.halfWidthAdsHtml;
							break;
						default:
							// one-fourth
							gridAdsHtml = boostPFSTemplate.oneFourthAdsHtml;
					}
				gridAdsHtml = gridAdsHtml.replace(/{{classIdentifier}}/g, ads_data.grid_ads[x].class);
				if (ads_data.grid_ads[x].render_location == 0 && i == 0){
					$(gridAdsHtml).insertBefore(singleGridBlock);
				}else if (i == render_location_index) {
					$(gridAdsHtml).insertAfter(singleGridBlock);
				}
			}
		}

		var product = data[i];
		var productVariants = product.variants;
		var productImages = product.images_info;
		var parentBlock = $(`[data-id="${product.id}"]`);
		var sizeVariantContainer = parentBlock.find('.size-variants');
		var quickBuyContainer = parentBlock.find('.quick-buy-container');
		var quickBuyContainerTemplate = boostPFSTemplate.quickBuyContainer
		var variantMainImage = '';
		var variantMainImageAltText = '';
		var variantSwapImage = '';
		var variantSwapImageAltText = '';
		let relatedProductIds = `gid://shopify/Product/${product.id}`;

		if (variantMainImage === '') {
			variantMainImage = productImages[0] ? productImages[0].src : product.featured_image.src;
			variantMainImageAltText = productImages[0] && productImages[0].alt ? productImages[0].alt: product.title;
		}

		const jitterBitField = product.metafields.filter(item => item.namespace == 'jitterbit' && item.key == 'related_products');
		if (jitterBitField[0]) {
			if (jitterBitField[0].value) relatedProductIds = JSON.parse(jitterBitField[0].value);
		}

		//Hide products that don't have images or aren't available
		if (productImages.length == 0 || !product.available){
			parentBlock.hide();
		};

		for (let x = 0; x < productImages.length; x++) {
			var imgSrc = (productImages[x].src) ? productImages[x].src : 'https:' + productImages[x];
			if (imgSrc === variantMainImage) {
				if (typeof productImages[x+1] !== 'undefined') {
					// if next image exists, use it
					variantSwapImage = (productImages[x+1].src) ? productImages[x+1].src : 'https:' + productImages[x+1];
					variantSwapImageAltText = (productImages[x+1].alt) ? productImages[x+1].alt: product.title;
				} else {
					// use current image, or change this to swap to first image (productImages[0].src)
					variantSwapImage = imgSrc;
					variantSwapImageAltText = variantMainImageAltText;
				}

				break;
			}
		}

		// show default "no_image" for color swatch that has no matching product variant image
		if(!variantSwapImage){
			variantMainImage = 'https:'+boostPFSConfig.general.no_image_url;
			variantSwapImage = variantMainImage
		}

		parentBlock.find('.boost-pfs-filter-product-item-image-link').html(boostPFSTemplate.gridMainImage.replace(/{{image}}/g, generateFlexibleProductImage(variantMainImage, variantMainImageAltText)));
		if (parentBlock.hasClass('has-bc-swap-image')) {
			parentBlock.find('.boost-pfs-filter-product-item-image-link').append(boostPFSTemplate.gridFlipImage.replace(/{{image}}/g, generateFlexibleProductImage(variantSwapImage, variantSwapImageAltText, true)));
		}

		quickBuyContainer.html(quickBuyContainerTemplate.replace(/{{product_id}}/g, `gid://shopify/Product/${product.id}`).replace(/{{related_products}}/g, relatedProductIds));

		const clickedButtonOpenClass = 'btn-quick-buy-toggle--open';

		function handleQuickBuyToggleClick(event) {
			openOrCloseQuickBuy(event.target);
		}

		function handleQuickBuyCloseClick(event) {
			openOrCloseQuickBuy(event.target.closest('.quick-buy-container').querySelector('.btn-quick-buy-toggle'));
		}

		function openOrCloseQuickBuy(clickedButtonElement) {
			if (clickedButtonElement.classList.contains(clickedButtonOpenClass)) {
				closeQuickBuy(clickedButtonElement);
			} else {
				openQuickBuy(clickedButtonElement);
			}
		}

		function openQuickBuy(clickedButtonElement) {
			// Close other open quick buy buttons
			document.querySelectorAll('.btn-quick-buy-toggle').forEach((quickBuyToggleButton) => {
				if (quickBuyToggleButton != clickedButtonElement) closeQuickBuy(quickBuyToggleButton);
			});

			// Open this quick buy button
			clickedButtonElement.classList.add(clickedButtonOpenClass);
			clickedButtonElement.textContent = clickedButtonElement.textContent.replace('+','-');
			const quickBuyDetailsElement = clickedButtonElement.closest('.quick-buy-container').querySelector('.quick-buy-details');
			if (quickBuyDetailsElement) {
				quickBuyDetailsElement.classList.add('tw-flex');
				quickBuyDetailsElement.classList.remove('tw-hidden');

				if (clickedButtonElement.dataset.product_id) {
					let relatedProductIds = '';
					if (clickedButtonElement.dataset.related_products) relatedProductIds = clickedButtonElement.dataset.related_products;

					const quickBuyOptionsElement = quickBuyDetailsElement.querySelector('.quick-buy-options');
					if (!quickBuyOptionsElement)
						addQuickBuyDetails(quickBuyDetailsElement, clickedButtonElement.dataset.product_id ,relatedProductIds);
				}
			}
		}

		function closeQuickBuy(clickedButtonElement) {
			clickedButtonElement.classList.remove(clickedButtonOpenClass);
			clickedButtonElement.textContent = clickedButtonElement.textContent.replace('-','+');
			const quickBuyDetailsElement = clickedButtonElement.closest('.quick-buy-container').querySelector('.quick-buy-details');
			if (quickBuyDetailsElement) {
				quickBuyDetailsElement.classList.add('tw-hidden');
				quickBuyDetailsElement.classList.remove('tw-flex');
			}
		}

		async function addQuickBuyDetails(quickBuyDetailsElement, mainProductId, relatedProductIds) {
			const quickBuyProductsData = await fetchQuickBuyProductsData(relatedProductIds);

			const oldQuickBuyOptionsElement = quickBuyDetailsElement.querySelector('.quick-buy-options');
			if (oldQuickBuyOptionsElement) oldQuickBuyOptionsElement.remove();

			const quickBuyOptionsElement = document.createElement('div');
			quickBuyOptionsElement.classList.add('quick-buy-options');

			let quickBuyCurrentlyActiveProduct = null;

			quickBuyProductsData.lists.forEach((productList) => {
				const productListElement = document.createElement('div');
				productListElement.classList.add('quick-buy-options-list', 'tw-mb-4');

				if (quickBuyProductsData.totalProductsAvailable === 1)
					productListElement.classList.add('tw-hidden');

				if (productList.products.length > 0) {
					const listTitleElement = document.createElement('p');
					listTitleElement.textContent = productList.title;
					listTitleElement.classList.add('tw-text-sm');
					productListElement.append(listTitleElement);

					const productListOptionElement = document.createElement('div');
					productListOptionElement.classList.add('quick-buy-swatches', 'tw-flex', 'tw-flex-wrap', 'tw-flex-row', 'tw-justify-start', 'tw-content-center', 'tw-items-center', 'tw-gap-4', 'tw-mt-2');

					productList.products.forEach((product) => {
						const productSwatchElement = document.createElement('div');
						productSwatchElement.classList.add('quick-buy-swatch', 'tw-block', 'tw-h-6', 'tw-w-6', 'tw-border', 'tw-border-solid', 'tw-rounded-full', 'tw-shadow-[inset_0_0_0_2px_#fff]', 'tw-bg-center', 'tw-bg-no-repeat', 'tw-bg-cover');

						if (product.tags) {
							const productColourTags = product.tags.filter((productTag) => productTag.includes('Colour:'));
							if (productColourTags.length) {
								const productColourImageFile = `${handleizeString(productColourTags[0].replace('Colour:',''))}.jpg`;

								productSwatchElement.style.backgroundImage = `url('${window.fileBaseUrl}${productColourImageFile}')`;
							}
						}

						if (product.images.nodes) {
							let productMainImage = 'https:'+boostPFSConfig.general.no_image_url;
							let productMainImageAlt = '';
							let productSwapImage = 'https:'+boostPFSConfig.general.no_image_url;
							let productSwapImageAlt = '';
							if (product.images.nodes[0]) {
								productMainImage = product.images.nodes[0].src;
								productSwapImage = product.images.nodes[0].src;
								if (product.images.nodes[0].alt) {
									productMainImageAlt = product.images.nodes[0].alt;
									productSwapImageAlt = product.images.nodes[0].alt;
								}
							}
							if (product.images.nodes[1]) {
								productSwapImage = product.images.nodes[1].src;
								if (product.images.nodes[1].alt) {
									productSwapImageAlt = product.images.nodes[1].alt;
								}
							}

							productSwatchElement.dataset.productMainImage = productMainImage;
							productSwatchElement.dataset.productSwapImage = productSwapImage;

							if (!productMainImageAlt) productMainImageAlt = product.title;
							if (!productSwapImageAlt) productSwapImageAlt = product.title;
							productSwatchElement.dataset.productMainImageAlt = productMainImageAlt;
							productSwatchElement.dataset.productSwapImageAlt = productSwapImageAlt;
						}

						if (product.variants.nodes) productSwatchElement.dataset.productVariants = JSON.stringify(product.variants.nodes);

						if (product.id === mainProductId) {
							productSwatchElement.classList.add('quick-buy-swatch--active', 'tw-border-[#666666]');
							quickBuyCurrentlyActiveProduct = product;
						} else {
							productSwatchElement.classList.add('tw-border-[#c4c4c4]', 'tw-cursor-pointer');
						}

						productSwatchElement.addEventListener('click', handleQuickBuySwatchElementClick);

						productListOptionElement.append(productSwatchElement);
					});
					productListElement.append(productListOptionElement);

					quickBuyOptionsElement.append(productListElement);
				}
			});

			const quickBuySizesListElement = document.createElement('div');
			quickBuySizesListElement.classList.add('quick-buy-options-list');

			let quickBuySizesTitleText = 'Select a size:';
			if (quickBuyCurrentlyActiveProduct) {
				if (quickBuyCurrentlyActiveProduct.options) {
					const quickBuyCurrentlyActiveProductDenominationsOptions = quickBuyCurrentlyActiveProduct.options.filter((option) => option.name === 'denomination');
					if (quickBuyCurrentlyActiveProductDenominationsOptions.length > 0) quickBuySizesTitleText = 'Value:'
				} 
			}

			const quickBuySizesTitleElement = document.createElement('p');
			quickBuySizesTitleElement.textContent = quickBuySizesTitleText;
			quickBuySizesTitleElement.classList.add('tw-text-sm');
			quickBuySizesListElement.append(quickBuySizesTitleElement);

			const quickBuySizesElement = document.createElement('div');
			quickBuySizesElement.classList.add('quick-buy-sizes', 'tw-flex', 'tw-flex-wrap', 'tw-flex-row', 'tw-justify-start', 'tw-content-center', 'tw-items-center', 'tw-gap-1', '-tw-ml-1', 'tw-mt-1');
			quickBuySizesListElement.append(quickBuySizesElement);

			quickBuyOptionsElement.append(quickBuySizesListElement);


			const quickBuyLoadingElement = quickBuyDetailsElement.querySelector('.quick-buy-loading');
			quickBuyLoadingElement.classList.add('tw-hidden');
			quickBuyLoadingElement.classList.remove('tw-block');

			quickBuyOptionsWrapper = quickBuyDetailsElement.querySelector('.quick-buy-options-wrapper');
			if (quickBuyOptionsWrapper)
				quickBuyOptionsWrapper.append(quickBuyOptionsElement);

			if (quickBuyCurrentlyActiveProduct) {
				if (quickBuyCurrentlyActiveProduct.variants.nodes)
					await updateQuickBuyVariants(quickBuyDetailsElement, quickBuyCurrentlyActiveProduct.variants.nodes);
			}
		}

		async function fetchQuickBuyProductsData(relatedProductIds) {
			let relatedProductsGraphQuery = '';
		
			relatedProductIds.split(',').forEach((productId, index) => {
				relatedProductsGraphQuery += `product${index}: product(id: "${productId}") {
					availableForSale
					title
					id
					tags
					totalInventory
					options(first:10) {
						name
					}
					images(first:2) {
						nodes {
							src
							altText
						}
					}
					variants(first: 20) {
						nodes {
							id
							title
							availableForSale
						}
					}
				}`;
			});
		
			const options = {
				method: 'POST',
				headers: new Headers({
					'content-type': 'application/json',
					'X-Shopify-Storefront-Access-Token': window.gqlProductInfoStorefrontAccessToken,
				}),
				body: JSON.stringify({
					query: `
						query products {
							${relatedProductsGraphQuery}
						}
					`,
				}),
			};
		
			const relatedProductsRequest = await fetch('/api/2023-04/graphql.json', options);
			const relatedProductsData = await relatedProductsRequest.json();

			let lowStockThreshold = 5;
			if (window.theme.lowStockItemThreshold) lowStockThreshold = window.theme.lowStockItemThreshold;

			const productsLists = {
				totalProductsAvailable: Object.values(relatedProductsData.data).filter((product) => product && product.availableForSale).length,
				lists: [
					highStockProducts = {
						'title': 'Select Colour:',
						'products': Object.values(relatedProductsData.data).filter((product) => product && product.availableForSale && product.totalInventory > lowStockThreshold),
					},
					lowStockProducts = {
						'title': 'Limited Quantity:',
						'products': Object.values(relatedProductsData.data).filter((product) => product && product.availableForSale && product.totalInventory <= lowStockThreshold),
					},
				],
			};

			return productsLists;
		}

		async function handleQuickBuySwatchElementClick(event) {
			const clickedSwatchElement = event.target;

			const allSwatchElements = clickedSwatchElement.closest('.quick-buy-swatches').querySelectorAll('.quick-buy-swatch');

			if (allSwatchElements) {
				allSwatchElements.forEach((swatchElement) => {
					if (swatchElement === clickedSwatchElement) {
						swatchElement.classList.add('quick-buy-swatch--active', 'tw-border-[#666666]');
						swatchElement.classList.remove('tw-border-[#c4c4c4]', 'tw-cursor-pointer');
					} else {
						swatchElement.classList.remove('quick-buy-swatch--active', 'tw-border-[#666666]');
						swatchElement.classList.add('tw-border-[#c4c4c4]', 'tw-cursor-pointer');
					}
				});
			}

			const quickBuyDetailsElement = clickedSwatchElement.closest('.quick-buy-container').querySelector('.quick-buy-details');
			if (quickBuyDetailsElement && clickedSwatchElement.dataset.productVariants) {
				await updateQuickBuyVariants(quickBuyDetailsElement, JSON.parse(clickedSwatchElement.dataset.productVariants));
			}

			if (clickedSwatchElement.dataset.productMainImage) {
				const swatchProductMainImageElement = clickedSwatchElement.closest('.boost-pfs-filter-product-item').querySelector('.boost-pfs-filter-product-item-main-image');
				if (swatchProductMainImageElement) {
					let clickedSwatchElementMainProductImageAlt = '';
					if (clickedSwatchElement.dataset.productMainImageAlt)
						clickedSwatchElementMainProductImageAlt = clickedSwatchElement.dataset.productMainImageAlt;
					swatchProductMainImageElement.outerHTML = generateFlexibleProductImage(clickedSwatchElement.dataset.productMainImage, clickedSwatchElementMainProductImageAlt);
				}
			}

			if (clickedSwatchElement.dataset.productSwapImage) {
				const swatchProductSwapImageElement = clickedSwatchElement.closest('.boost-pfs-filter-product-item').querySelector('.boost-pfs-filter-product-item-flip-image');
				if (swatchProductSwapImageElement) {
					let clickedSwatchElementSwapProductImageAlt = '';
					if (clickedSwatchElement.dataset.productSwapImageAlt)
						clickedSwatchElementSwapProductImageAlt = clickedSwatchElement.dataset.productSwapImageAlt;
					swatchProductSwapImageElement.outerHTML = generateFlexibleProductImage(clickedSwatchElement.dataset.productSwapImage, clickedSwatchElementSwapProductImageAlt, true);
				}
			}
		}

		async function updateQuickBuyVariants(quickBuyDetailsElement, newVariants) {
			const quickBuySizesElement = quickBuyDetailsElement.querySelector('.quick-buy-sizes');

			if (quickBuySizesElement) {
				quickBuySizesElement.innerHTML = '';

				if (newVariants) {
					newVariants.forEach((variant) => {
						const newVariantElement = document.createElement('button');
						newVariantElement.classList.add('tw-block', 'tw-py-1', 'tw-px-2', 'tw-border', 'tw-border-solid', 'tw-border-black', 'tw-border-opacity-0');

						if (variant.id) newVariantElement.dataset.variantId = variant.id.replace('gid://shopify/ProductVariant/','');
						if (variant.title) newVariantElement.textContent = variant.title;

						if (variant.availableForSale) {
							newVariantElement.classList.add('tw-text-black', 'hover:tw-border-opacity-100', 'focus:tw-border-opacity-100');
						} else {
							newVariantElement.disabled = true;
							newVariantElement.classList.add('tw-text-[#666666]', 'tw-line-through');
						}

						newVariantElement.addEventListener('click', handleQuickBuyVariantClick);

						quickBuySizesElement.append(newVariantElement);
					});
				}
			}
		};

		async function handleQuickBuyVariantClick(event) {
			const clickedVariant = event.target;
			if (clickedVariant.dataset.variantId) {
				await CartJS.addItem(clickedVariant.dataset.variantId, 1, null, {
					'success': () => {
						const associatedQuickBuyButtonElement = clickedVariant.closest('.quick-buy-container').querySelector('.btn-quick-buy-toggle');
		
						if (associatedQuickBuyButtonElement)
						closeQuickBuy(associatedQuickBuyButtonElement);
					}
				});
			}
		}

		function handleizeString(string) {
			handleizedString = string.toLowerCase();
	
			const toReplace = ['"', "'", '\\', '(', ')', '[', ']'];
			for (let i = 0; i < toReplace.length; ++i) {
					handleizedString = handleizedString.replace(toReplace[i], '');
			}

			handleizedString = handleizedString.replace(/\W+/g, '-');
			if (handleizedString.charAt(handleizedString.length - 1) == '-') handleizedString = handleizedString.replace(/-+\z/, '');
			if (handleizedString.charAt(0) == '-') handleizedString = handleizedString.replace(/\A-+/, '');

			return handleizedString;
		};

		const quickBuyToggleButton = quickBuyContainer.find('.btn-quick-buy-toggle');
		if (quickBuyToggleButton) quickBuyToggleButton[0].addEventListener('click', handleQuickBuyToggleClick);

		const quickBuyCloseButton = quickBuyContainer.find('.btn-quick-buy-close');
		if (quickBuyCloseButton) quickBuyCloseButton[0].addEventListener('click', handleQuickBuyCloseClick);

		parentBlock.find('.open-modal').attr('data-variant-id', $(this).data('variant-id'));
	}

	// Size variant selector
// Unbind the click to have no issue in the boost filtering
$('.collection-main .collection-grid-container').unbind('click');
	$('.collection-main .collection-grid-container').on('click', '.single-product-block .size-variants a', function(e){
		e.preventDefault();
		var variantId = $(this).attr('data-variant-id');
		CartJS.addItem(variantId, 1);
	});

	setTimeout(function() {
		var ads_elements = document.querySelectorAll('.grid-ads');
		ads_elements.forEach(function (ele) {
			if (ele.children.length <= 0) {
				// remove element
				ele.remove();
			}
		});
	}, 3000);
	
};

// Build additional elements
Filter.prototype.afterRender = function(data) {
	if (!data) data = this.data;

	var totalProduct = '&#40;' + data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>&#41;';
	if (data.total_product == 1) {
		totalProduct = '&#40;' + data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>&#41;';
	}
	jQ('.boost-pfs-filter-total-product').html(totalProduct);
		
			jQ('#collectionFilterMenu h3').unbind('click');
			var filterMenuCategory = jQ('#collectionFilterMenu').detach();
			var windowWidthSize = jQ(window).width();
			$("#boost-pfs-filter-tree").prepend(filterMenuCategory);
			jQ('#collectionFilterMenu h3').on('click', function() {
				jQ(this).parent().parent().find('.boost-pfs-filter-option-content').slideToggle();
				if (jQ(this).attr('aria-expanded') === 'true') {
					jQ(this).attr('aria-expanded', 'false');
					jQ(this).find('span').addClass('up');
				} else{
					jQ(this).attr('aria-expanded', 'true');
					jQ(this).find('span').removeClass('up');
				}
			});

			var closeFilterMenu = function() {
				var filterMenuTrigger = $('#collectionFilterMenu h3');
				filterMenuTrigger.parent().parent().find('.boost-pfs-filter-option-content').slideUp();
				filterMenuTrigger.attr('aria-expanded', 'false');
				filterMenuTrigger.find('span').addClass('up');
			};

			var openFilterMenu = function() {
				var filterMenuTrigger = $('#collectionFilterMenu h3');
				filterMenuTrigger.parent().parent().find('.boost-pfs-filter-option-content').slideDown();
				filterMenuTrigger.attr('aria-expanded', 'true');
				filterMenuTrigger.find('span').removeClass('up');
			};

			if (windowWidthSize < theme.tabletViewMaxWidth && $('#collectionFilterMenu').hasClass('mobile-collapse')) {
				closeFilterMenu();
			}

			jQ(window).resize(function(){
				windowWidthSize = $(window).width();
				if (windowWidthSize < theme.tabletViewMaxWidth && $('#collectionFilterMenu').hasClass('mobile-collapse')) {
					closeFilterMenu();
				} else {
					openFilterMenu();
				}
			});

	jQ('body').find('.boost-pfs-filter-skeleton-button').remove();

	// Prevent double tap on iOS
	var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	if (isiOS) {
		Utils.isMobile() && jQ(".boost-pfs-filter-product-item").find("a").on("touchstart", function() {
			isScrolling = !1
		}).on("touchmove", function() {
			isScrolling = !0
		}).on("touchend", function() {
			isScrolling || (window.location = jQ(this).attr("href"))
		});
	}

	// Build Image Swap. Put this function here to impprove the pagespeed.
	swapImage(data);

	// Build Equal Height
	if (Globals.queryParams.display !== 'list') {
		equalHeight(data);
	};

	jQ(window).resize(function() {
		if (Globals.queryParams.display !== 'list') {
			equalHeight(data);
		}
	});

	// Build Event Color Swatch
	if (boostPFSThemeConfig.custom.swatch_color_event_change_image != 'none') {
		eventColorSwatches(boostPFSThemeConfig.custom.swatch_color_event_change_image);
	}

	if (typeof boostRemoveImageLoadingAnimation == 'function') {
		boostRemoveImageLoadingAnimation(jQ(Selector.products).find('[data-boost-image-loading-animation]'));
	}
			/* Filter Sticky */
			if (boostPFSThemeConfig.custom.hasOwnProperty('enable_filter_sticky') && boostPFSThemeConfig.custom.enable_filter_sticky && !Utils.isMobile()) {
					if(jQ('.boost-pfs-filter-left-col-inner').length > 0){
							var stickyElemet = '.boost-pfs-filter-left-col-inner';
							var stickyElementParent = '.boost-pfs-filter-left-col';
							var startElement = '.boost-pfs-filter-products';
							jQ(stickyElemet).stickTo(startElement,stickyElementParent);
					}
			}
			/* End Filter Sticky */

			/* Init Sticky Mobile */
			stickyFilterMobile();
			jQ(window).scroll(stickyFilterMobile);

			/* Init Sticky Horizontal */
			stickyFilterHorizontal();
			jQ(window).scroll(stickyFilterHorizontal);

	/* Layout Fullwidth Page */
	if (boostPFSThemeConfig.custom.hasOwnProperty('layout_type') && boostPFSThemeConfig.custom.layout_type == 'fullwidth' && !Utils.isMobile()) {
		jQ('body').addClass('boost-pfs-filter-fullwidth-page');
	}
};

	/* Filter Sticky */
	jQ.fn.stickTo = function(startElement, stickyElementParent) {
			/* constants */    
			var showingHeader = false;
			var headerHeight = 0; /* change the header height here */
			var headerSelector = '';  
			var $window = jQ(window);  
			var $startElement = jQ(startElement);               
			var _this = this;          

			/* variables */
			var lastScrollTop = $window.scrollTop();  

			/* sticky method */
			var setPosition = function() {
			/* declarations */
			var width = jQ(stickyElementParent).outerWidth();
			var $windowHeight = $window.height();
			var $contentHeight = $startElement.outerHeight(true);     
			var $contentTop = $startElement.offset().top;      

			var sidebarHeight = _this.outerHeight();
			var sidebarTop = _this.offset().top;
			var sidebarBottom = sidebarTop + sidebarHeight;

			var scrollTop = $window.scrollTop();                        
			var scrollBottom = scrollTop + $windowHeight;  
			var isScrollingDown = (scrollTop > lastScrollTop);

			var endPos = $contentTop + $contentHeight;
			
			/* Match Header Height Sticky */
			
			if(jQ('.site-header-wrapper .action-area').length > 0){
		/* For the Boundless theme */
					headerSelector = '.site-header-wrapper .action-area';
			} else if (jQ('.site-header .nav-bar').length > 0) {
		/* For the Venture theme */
					headerSelector = '.site-header .nav-bar';
			} else if (jQ('.site-header--fixed').length > 0) {
		headerSelector = '.site-header--fixed';
	} else if (jQ('.header-wrapper--fixed').length > 0) {
		headerSelector = '.header-wrapper--fixed';
	}
	
			if(headerSelector != ''){
			headerHeight = jQ(headerSelector).outerHeight();
			}

			jQ(window).scroll(function(){
					showingHeader = false;
					/* For the Boundless, Venture theme */
					if(jQ('.js-sticky-action-bar').length > 0 || jQ('.site-header .sticky--open').length > 0 || jQ('.site-header--fixed' || jQ('.header-wrapper--fixed'))){
							showingHeader = true;
					}
					});
			/* End Match Header Height Sticky */


			if (sidebarHeight > $contentHeight) {
					_this.removeClass('boost-pfs-filter-stick');
					jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');           
					_this.css({
					position: 'initial'
					});
					return;
			}

			if (scrollTop <= $contentTop) { /* Initial Position */
					_this.removeClass('boost-pfs-filter-stick');
					jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');          
					_this.css({
							position: 'initial',
							width: '100%'
					});
					return;
			}      

			if ((scrollBottom >= endPos)) { /* End Position  */          
					var absolutePos = endPos - sidebarHeight - $contentTop;
					if (absolutePos > 0) {
							_this.removeClass('boost-pfs-filter-stick');
							jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');            
							_this.css({
									position: 'absolute',
									top: absolutePos,
									bottom: 'unset',
									width: width
							});
					} 
					return;
			}
			/* when scrolling down */  
			if (isScrollingDown) {          
					if (scrollBottom < sidebarBottom) { /* Until reach the sidebar bottom  */
					if (_this.css('position') !== 'relative') {
							_this.removeClass('boost-pfs-filter-stick');
							jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');          
							_this.css({
								position: 'relative',
								top: sidebarTop - $contentTop,
								bottom: 'unset',
								width: '100%'
							});          
					}
					} else if (scrollBottom >= sidebarBottom && scrollTop > $contentTop) { /* Sticky sidebar */                
							_this.addClass('boost-pfs-filter-stick');
							jQ('body').addClass('boost-pfs-filter-stick-vertical-body');                        

							_this.css({
									position: 'fixed',
									top: showingHeader ? (headerHeight + 'px') : '20px',
									bottom: $windowHeight > (sidebarHeight + headerHeight) ? 'unset' : 0,
									width: width,
									left: 'auto'
							});
					}
			} else { /* when scrolling up */     
					if ((scrollTop - headerHeight) > sidebarTop) {  /* Until reach the sidebar top  */   
					if (_this.css('position') !== 'relative') {
							_this.removeClass('boost-pfs-filter-stick');
							jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');           
							_this.css({
								position: 'relative',
								top: sidebarTop - $contentTop,
								bottom: 'unset',
								width: '100%'
							});          
					}
					} else if (scrollTop <= (endPos - sidebarHeight)) { /* Sticky sidebar */
							_this.addClass('boost-pfs-filter-stick');
							jQ('body').addClass('boost-pfs-filter-stick-vertical-body');                        

							_this.css({
									position: 'fixed',
									top:  showingHeader ? (headerHeight + 'px') : '20px',
									bottom: 'unset',
									width: width,
									left: 'auto'
							});
					}
			}

			/* save last scroll position */
			lastScrollTop = $window.scrollTop();
			};

			/* on window resize */
			jQ(window).resize(function() {        
					setPosition();
			});

			/* on scroll */
			jQ(window).scroll(setPosition);
			setPosition();
			
			jQ(document).on('click', '.boost-pfs-filter-button.boost-pfs-filter-option-title-heading', function() {
					setTimeout(setPosition, 400);
			});
	};

	/* End filter sticky */

	var original_onClickEventProductDisplayType = ProductDisplayType.prototype._onClickEvent;
	ProductDisplayType.prototype._onClickEvent = function(event) {
			// Call the original function in our app lib.
			// We don't have to copy a very big function out here to modify.
			// function.call(this, param1, param2) binds the "this" pointer and params to the original function.
			original_onClickEventProductDisplayType.call(this, event);

			// Do your custom code after the original function has run
			/*  View As Type 2/3/4/5/6 */
			if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
					jQ('.boost-pfs-filter-top-display-type').addClass('boost-pfs-filter-view-as-click');
					jQ('.boost-pfs-filter-top-display-type').removeClass(function(index, css) {
							return (css.match (/(^|\s)grid-\S+/g) || []).join(' ');
					}).addClass(jQ(event.target).data('view'));
			}
	}

ProductListPlaceholder.prototype.render = function() {
	// Set limit number for product skeleton
	var placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow;
	// Build placeholder items
	var placeholderItem = this.compileTemplate();
	this.$element = [];
	for (var i = 0; i < placeholderLimit; i++) {
		this.$element.push(jQ(placeholderItem));
	}
	// Show placeholder before send filter request OR hide it after get filter data
	if (!this.isFetchedProductData) {
		this.setShow();
	} else {
		this.setHide();
	}
}

ProductListPlaceholder.prototype.compileTemplateExtra = function() {
	var display = Globals.queryParams.display
	switch (display) {
		case 'list':
			//Todo: Build placeholder for List mode
			var template = boostPFSTemplate.productListPlaceholderHtml;
			var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio);
			var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4; // It mean w1:h1.4
			/**
			 * Set product class for product skeleton (to set column, style, etc.)
			 * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
			 */
			break;
	}
	return template
		.replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
		.replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
		.replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
		.replace(/{{paddingTop}}/g, imgRatio * 100)
}

/* Prevent conflict with theme vendor js */
Array.prototype.insert = function(a, b) {}

/* Math qual Height */
function equalHeight(data) {
	var equal_i = -1;
	var equal_els = [];
	var equal_element = null;

	// Equal Height Title
	jQ('.boost-pfs-filter-product-item').each(function(i, element) {

		var offsetTop = jQ(element).offset().top;
		if (!equal_element || equal_element.offset().top !== offsetTop) {
			equal_element = jQ(element);
			equal_i++;
		}

		if (!equal_els[equal_i]) {
			equal_els[equal_i] = [];
		}
		equal_els[equal_i].push(element);
	});

	for (var i = 0; i < equal_els.length; i++) {
		var max = 0;
		var maxRatio = 0;
		var iLength = equal_els[i].length;

		for (var j = 0; j < equal_els[i].length; j++) {
			var item = equal_els[i][j];
			var height = jQ(item).find('.boost-pfs-filter-product-bottom-inner').height();
			max = Math.max(max, height);

		}

		jQ(equal_els[i]).find('.boost-pfs-filter-product-bottom-inner').css({ 'min-height': max });

	}

	var equal_height = boostPFSFilterConfig.general.equal_height;

	if (equal_height != 'false') {
		var cropImagePosition = boostPFSFilterConfig.general.cropImagePossitionEqualHeight;

		var widthImage = jQ('.boost-pfs-filter-product-item').width();
		var indexData = 0;

		// For Ratio
		if (equal_height != 'false' && equal_height != 'auto') {
			var heightImage = 0;
			var widthImage = jQ('.boost-pfs-filter-product-item').width();
			if (equal_height != 'false' && equal_height != 'auto' && equal_height != 'other') {
				var ratioWidthHeight = boostPFSThemeConfig.custom.equal_height;
			} else {
				var ratioWidthHeight = '';
			}

			var ratioWidthHeightOther = boostPFSThemeConfig.custom.ratio_width_height_other;
			if (ratioWidthHeightOther == '' && ratioWidthHeight == '') {
				return null;
			} else {
				if (equal_height != 'other') {
					ratioWidthHeight = ratioWidthHeight.split(':');
					ratioWidthHeight = parseInt(ratioWidthHeight[1]) / parseInt(ratioWidthHeight[0]);
					heightImage = widthImage * ratioWidthHeight;
				} else if (ratioWidthHeightOther != '' && equal_height == 'other') {
					ratioWidthHeightOther = ratioWidthHeightOther.split(':');
					ratioWidthHeightOther = parseInt(ratioWidthHeightOther[1]) / parseInt(ratioWidthHeightOther[0]);
					heightImage = widthImage * ratioWidthHeightOther;
				}
			}
			jQ('.boost-pfs-filter-product-item-image-link').css({ 'padding-top': heightImage + 'px' }).addClass('boost-pfs-filter-crop-image-position-' + cropImagePosition);;

		}
	}
}

// Swap Image
function swapImage(data) {
	if (!Utils.isMobile()) {
		if (boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
			boostPFSThemeConfig.custom.active_image_swap == true) {
			var dataSrcSetFlipImg = '',
				dataSrcFlipImg = '',
				flipImageAlt = '',
				dataSizes = 'auto',
				dataWidths = '',
				html = '';

			jQ(".boost-pfs-filter-product-item").each(function() {
				var productItemSelector = jQ(this);
				var imgSelector = productItemSelector.find('.boost-pfs-filter-product-item-main-image');

				if (typeof imgSelector.data('img-flip-src') != 'undefined' &&
					imgSelector.data('img-flip-src') != '') {
					dataSrcFlipImg = imgSelector.data('img-flip-src');
					dataSrcSetFlipImg = imgSelector.data('img-flip-srcset');
					flipImageAlt = imgSelector.attr('alt');
					dataWidths = imgSelector.data('widths');
					mainImgWidth = imgSelector.attr('width');
					mainImgHeight = imgSelector.attr('height');
					html = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
						'data-srcset="' + dataSrcSetFlipImg + '" ' +
						'data-src="' + dataSrcFlipImg + '" ' +
						'data-widths="[' + dataWidths + ']" ' +
						'data-sizes="' + dataSizes + '" ' +
						'src="' + boostPFSImgDefaultSrc + '" ' +
						'alt="' + flipImageAlt + '"' +
						'width="' + mainImgWidth + '"' +
						'height="' + mainImgHeight + '"' +
						'loading="lazy" />';

					productItemSelector.find('.boost-pfs-filter-product-item-image-link').append(html);
				}

			});
		}
	}
}

// Build Placeholder for the first load
function boostRemoveImageLoadingAnimation($selector) {
	if ($selector.length) {
		$selector.removeAttr('data-boost-image-loading-animation');
	}
}
/* Expand Filter */
	jQ(document).ready(function() {
			jQ('.boost-pfs-filter-custom-filter-button').on('click', function(){
					jQ('body').toggleClass('boost-pfs-filter-custom-drawer-open');
			});
			jQ('.boost-pfs-filter-custom-drawer-close').click(function(){
					jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
			});
			jQ('.boost-pfs-filter-custom-drawer-overlay').click(function(){
					jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
			});
	});

	/* Sticky Filter Mobile */
	function stickyFilterMobile() {
			var windowTop = jQ(window).scrollTop();
	var heightFooter = 0;
			var divTop = 0;
			var divHeight = 0;
	if(jQ("#shopify-section-footer").length > 0){
		heightFooter = jQ("#shopify-section-footer").height();
	}
	if(jQ(".boost-pfs-filter-wrapper").length > 0){
		divTop = jQ('.boost-pfs-filter-wrapper').offset().top;
	}
	if(jQ(".boost-pfs-filter-wrapper").length > 0){
		divHeight = jQ(".boost-pfs-filter-wrapper").height();
	}

			if (windowTop > divTop + divHeight - heightFooter){
					jQ('body').removeClass('boost-pfs-mobile-stick');
			} else if (windowTop > divTop) {
					jQ('body').addClass('boost-pfs-mobile-stick');
			} else {
					jQ('body').removeClass('boost-pfs-mobile-stick');
			}
	}

	/* Sticky Filter Desktop Horizontal */
	function stickyFilterHorizontal() {

			if(jQ('.boost-pfs-filter-tree-h-sticky-filter').length > 0 && !Utils.isMobile()){
					var windowTop = jQ(window).scrollTop();
		var divTop = 0;
		if(jQ('.boost-pfs-filter-wrapper').length > 0){
			divTop = jQ('.boost-pfs-filter-wrapper').offset().top;
		}
					
					if (windowTop > divTop) {
					jQ('body').addClass('boost-pfs-filter-horizontal-sticky-body');
					} else {
					jQ('body').removeClass('boost-pfs-filter-horizontal-sticky-body');
					}
			}
	}

})();

// Create different media for product card on PLP
function generateFlexibleProductImage(src, altText = '', isFlipImage = false) {
  const srcsetMedia = [
    {
      screenSize: 1440,
      imageSize: 320,
    }
  ];
  const [imageUrl, version] = src.split('?');
  const extensionIndex = imageUrl.lastIndexOf('.');
  const imageLinkWithoutExtensions = imageUrl.slice(0, extensionIndex);
  const extension = imageUrl.slice(extensionIndex);

  const imageSources = srcsetMedia.map(media => {
    const alteredImgLink = imageLinkWithoutExtensions.concat(`_${media.imageSize}x`).concat(extension).concat(`?${version}`);

    return `<source srcset="${alteredImgLink}" width="${media.imageSize}" media="(max-width: ${media.screenSize}px)"/>`;
  })

  const imageSrcAttr = imageLinkWithoutExtensions.concat(`_375x`).concat(extension).concat(`?${version}`);

  return `
    <picture class="${ isFlipImage ? 'boost-pfs-filter-product-item-flip-image' : 'boost-pfs-filter-product-item-main-image' }">
      ${ imageSources.join('')}
      <img src="${imageSrcAttr}" class="lazyload" loading="lazy" alt="${altText}">
    </picture>
  `;
}
